/** Exact Nodus locations keep retained files distinct even within the same region class. */
export const storageLocations = [
  { value: "us-1", label: "United States 1" },
  { value: "us-8", label: "United States 8" },
  { value: "eu-1", label: "Europe 1 (Finland)" },
  { value: "eu-2", label: "Europe 2 (France)" },
];
const names: Record<string, string> = { ...Object.fromEntries(storageLocations.map(({ value, label }) => [value, label])), "eu-3": "Europe 3 (Iceland)" };
const legacyLocations: Record<string, string> = { "us-central1": "us-1", "eu-north1": "eu-1", "eu-west1": "eu-2", "eu-north2": "eu-3" };
/** Display restored routing values without rewriting a saved or uncertain request. */
export const spotLocationID = (location?: string) => legacyLocations[location ?? ""] ?? location;
export const spotLocationName = (location?: string, name?: string) => name || names[spotLocationID(location) ?? ""] || "Location unavailable";
